import { useField } from 'formik'
import React, { forwardRef, useImperativeHandle } from 'react'
import FWOLimitedTextAreaInput from '../../form/FWOLimitedTextAreaInput'

export interface IDecisionReviewProps {
  decision: string
  reasonBehindWrongDecision: string
  evidenceForWrongDecision: string
  expectedOutcome: string
}

const DecisionReview = forwardRef((props: IDecisionReviewProps, ref) => {
  const [, , decisionHelpers] = useField(props.decision)
  const [, , reasonBehindWrongDecisionHelpers] = useField(
    props.reasonBehindWrongDecision
  )
  const [, , evidenceForWrongDecisionHelpers] = useField(
    props.evidenceForWrongDecision
  )
  const [, , expectedOutcomeHelpers] = useField(props.expectedOutcome)
  useImperativeHandle(ref, () => ({
    clear() {
      decisionHelpers.setValue('')
      reasonBehindWrongDecisionHelpers.setValue('')
      evidenceForWrongDecisionHelpers.setValue('')
      expectedOutcomeHelpers.setValue('')
    },
  }))

  return (
    <div>
      <fieldset
        id="decisionReviewSection"
        className="decisionreview-fieldset-title"
      >
        <FWOLimitedTextAreaInput
          name={props.decision}
          label="What decision do you want reviewed? (150 character limit) "
          placeholder=""
          required={true}
          aria-label="What decision do you want reviewed?"
          rows={5}
          limit={150}
        />
        <FWOLimitedTextAreaInput
          name={props.reasonBehindWrongDecision}
          label="Why do you think we made the wrong decision? (350 character limit) "
          placeholder=""
          required={true}
          aria-label="Why do you think we made the wrong decision?"
          rows={5}
          limit={350}
        />
        <FWOLimitedTextAreaInput
          name={props.evidenceForWrongDecision}
          label="What evidence do you have that we made the wrong decision? (350 character limit) "
          placeholder=""
          required={true}
          aria-label="What evidence do you have that we made the wrong decision?"
          rows={5}
          limit={350}
        />
        <FWOLimitedTextAreaInput
          name={props.expectedOutcome}
          label="What outcome are you looking for? (350 character limit) "
          placeholder=""
          required={true}
          aria-label="What outcome are you looking for?"
          rows={5}
          limit={350}
        />
      </fieldset>
    </div>
  )
})

DecisionReview.displayName = 'DecisionReview'
export default DecisionReview
